import { marked } from 'marked';

export function getConfig(wrapper, botId) {
	
	var xhttp = new XMLHttpRequest();
	xhttp.onreadystatechange = function () {
		if (this.readyState == 4 && this.status == 200) {
			const response = JSON.parse(this.responseText);
			const config = response.body.widget_styles;

			parseResult(wrapper, config);
		}
	};
	xhttp.open(
		"GET",
		`https://${process.env.AUTOBOTS_API}.${process.env.DOMAIN}/api/v1/autobots/autobot-tiny/${botId}`,
		true
	);
	xhttp.setRequestHeader("content-type", "application/json");
	xhttp.setRequestHeader("Authorization", "Basic YXV0b2JvdDppcm9uaGlkZQ==");
	xhttp.send();
}

// Alert! side effects
export function parseResult(wrapper, config, init = true) {
	
	if (process.env.NODE_ENV != "production") {
		console.log({ wrapper });
		console.log({ config });
	}

	// Posible Invalid properties with this version, set for default
	if (!config.configuration_version || config.configuration_version < 101) {
		config.cta_right_position = null;
		config.cta_bottom_position = null;
		config.chat_bottom = null;
		config.chat_right = null;
	}

	wrapper.footer.show = config.show_footer;

	const cookiesAllowedCookie = getCookie("cookiesAllowed")

	wrapper.cookieBanner = {
		show: (config.cookieBannerText ?? '') !== "" && (cookiesAllowedCookie === null || cookiesAllowedCookie === "none"),
		text: marked.parse(config.cookieBannerText ?? ''),
		allowAllText: config.cookieBannerAllowAllText,
		configureText: config.cookieBannerConfigureText,
		cancelText: config.cookieBannerCancelText,
		allowStrictText: config.cookieBannerAllowStrictText,
		rejectAllText: config.cookieBannerRejectAllText,
		configurationText: marked.parse(config.cookieBannerConfigurationText ?? ''),
		rejectedText: marked.parse(config.cookieBannerRejectedText ?? ''),

		backgroundColorTransparent: config.cookieBackgroundColor,
		backgroundColor: config.cookieBackgroundColor,
		shadowColor: config.cookieShadowColor,
		textColor: config.cookieTextColor,
		separatorColor: config.cookieSeparatorColor,
		buttonBackgroundColor: config.cookieButtonBackgroundColor,
		buttonBorderColor: config.cookieButtonBorderColor,
		buttonTextColor: config.cookieButtonTextColor,
		buttonHoverBackgroundColor: config.cookieButtonHoverBackgroundColor,
		buttonHoverBorderColor: config.cookieButtonHoverBorderColor,
		buttonHoverTextColor: config.cookieButtonHoverTextColor,
		highlightedButtonBackgroundColor: config.cookieHighlightedButtonBackgroundColor,
		highlightedButtonBorderColor: config.cookieHighlightedButtonBorderColor,
		highlightedButtonTextColor: config.cookieHighlightedButtonTextColor,
		highlightedButtonHoverBackgroundColor: config.cookieHighlightedButtonHoverBackgroundColor,
		highlightedButtonHoverBorderColor: config.cookieHighlightedButtonHoverBorderColor,
		highlightedButtonHoverTextColor: config.cookieHighlightedButtonHoverTextColor,
	}

	wrapper.metaInjection = config.meta_injection;
	wrapper.alignment = config.alignment || "right";
	wrapper.autoStart = config.auto_start === false ? false : true;

	wrapper.header = {
		...wrapper.header,
		...{
			showImage: config.showImage || false,
			image: config.header_image || "",
			text: config.header_text || "Imbee Bot",
			color: config.header_font_color || "#EAE7DC",
			fontSize: config.header_font_size || "24px",
			fontFamily: config.header_font_type || "Courier",
			backgroundColor: config.header_color || "#FFF",
			headerTop: config.header_top || "0px",
			headerLeft: config.header_left || "0px",
			subtitleText: config.subtitle_text || "", 
			subtitleColor: config.subtitle_font_color || "#ee0000",
			fontSubtitleSize: config.subtitle_font_size || "14px",
			fontSubtitleFamily: config.subtitle_font_type || "Courier",
			imageSize: config.image_size || "80%",
			subtitleTop: config.subtitle_top || "0px",
			subtitleLeft: config.subtitle_left || "0px",
		},
	};

	wrapper.chat = {
		...wrapper.chat,
		...{
			width: config.width || "380px",
			height: config.height || "630px",
			backgroundColor: config.chat_background_color,
			placeholder: config.placeholder_text || "Escribe aquí...",
			verticalPadding: config.chat_bottom || "100px",
			horizontalPadding: config.chat_right || "20px",
			customCss: config.custom_css
			? "/*string-css*/" + config.custom_css
			: "/*full-css*/",
			lazyLoading: config.lazy_loading === false ? false : true,
			openOnShow: config.remember_state || false,
			autoOpenChatbot: config.auto_open_chatbot || false
		},
	};

	wrapper.chat.options = {
		...wrapper.chat.options,
		...{
			autofocus: config.autofocus,
			copyButton: config.copy_button,
			copyButtonText: config.copy_button_text,
			autocomplete: config.autocomplete,
			toggleTime: config.toggle_time,
			htmlActive: config.html_active,
			leftProfile: config.show_left_avatar ? config.logo_profile : "",
			rightProfile: config.show_right_avatar ? config.right_logo_profile : "",
			soft_scroll: config.soft_scroll,
			close_alert: config.close_alert,
			send_view_stanzas: config.send_view_stanzas,
			send_read_enabled: config.send_read_enabled,
			virtual_user_by_cookie: config.virtual_user_by_cookie,
			scroll_down_indicator: config.scroll_down_indicator,
			css_code: config.css_code,
			custom_font : config.custom_font,
			custom_font_name : config.custom_font_name,
		},
	};
	window.imbeeLog = window.imbeeLog ? "parser " + window.imbeeLog + " \n" + config.css_code : "parser " + config.css_code;

	wrapper.chat.speech = {
		...wrapper.chat.speech,
		...{
			enable: config.speech || false,
			always: config.speech_always || false,
			lang: config.speech_lang || "es-ES",
			voice:
				config.speech_voice || "Microsoft Helena Desktop - Spanish (Spain)",
		},
	};

	wrapper.chat.recognition = {
		...wrapper.chat.recognition,
		...{
			enable: config.recognition || false,
			lang: config.recognition_lang || "es-ES",
			placeholder: config.recognition_placeholder
				? config.recognition_placeholder
				: "Escuchando...",
			autoSend: config.recognition_auto_send || false,
		},
	};

	wrapper.callToAction = {
		...wrapper.callToAction,
		...{
			show: config.cta_enabled || false,
			delay: config.cta_delay || 3000,
			text: config.cta_text || "Can I help you? 🤖",
			fontFamily: config.cta_font_family || "Arial,Helvetica,sans-serif,Lato",
			fontSize: config.cta_font_size || "14px",
			fontColor: config.cta_font_color || "rgb(0, 0, 0)",
			backgroundColor: config.cta_background_color || "rgb(255, 255, 255)",
			horizontalPadding: config.cta_right_position || "0px",
			verticalPadding: config.cta_bottom_position || "80px",
		},
	};

	wrapper.textBadge = {
		...wrapper.textBadge,
		...{
			show: config.show_top_badge || false,
			animation: config.top_badge_animation || "fade",
			text: config.top_badge_content || "ONLINE HELP",
			color: config.top_badge_font_color || "rgb(231, 90, 79)",
			backgroundColor: config.top_badge_background_color || "#FFF",
			fontSize: config.top_badge_font_size || "10px",
			fontFamily: config.top_badge_font_family || "Arial",
			fontWeight: config.top_badge_font_weight || "bold",
		},
	};

	wrapper.closeCross = {
		...wrapper.closeCross,
		...{
			show: config.show_close_cross || false,
			
			color: config.close_cross_font_color || "white",
			backgroundColor: config.close_cross_background_color || "rgba(170, 170, 170, 0.68)",
			
			fontSize: config.close_cross_font_size || "14px",
			size: config.close_cross_size || "29px",
			top: config.close_cross_top || "-23px",
			right: config.close_cross_right || "-16px",
		},
	};

	wrapper.bubble = {
		...wrapper.bubble,
		...{
			delay: config.bubble_show_timeout || 1000,
			sameDirection: config.same_direction || false,
			closeIcon: config.bubble_close_icon || 2,
			color: config.bubble_font_color || config.header_color|| "#FFF",
			backgroundColor: config.bubble_color || config.header_font_color || "#E85A4F",
			bubbleAnimation: config.bubble_animation || "bounceUp",
			verticalPadding: config.bubble_bottom || "20px",
			horizontalPadding: config.bubble_right || "20px",
			image:
				config.bubble_image ||
				"https://s3.eu-west-3.amazonaws.com/imbee.xyz/chat/2123178a54c2618a9905e9010d076900f28f5a9a/70705670e816e9d2ca4f6aed75ccf4c671dea7ff.png",
			showImage: config.bubble_show_image || false,
		},
	};

	wrapper.loader = {
		...wrapper.loader,
		...{
			show: config.show_loader || false,
			type: config.loader || "GridLoader",
			color: config.loader_color || "rgb(231 90 79)",
			backgroundColor: config.loader_background || "#fffdfe",
		},
	};

	wrapper.userCookie = {
		...wrapper.userCookie,
		...{
			expires: config.cookie_timeout + config.cookie_time_unit || "session",
			name: config.cookie_name || "imbee",
		},
	};

	// wrapper.badge = {
	// 	...wrapper.badge,
	// 	...{
	// 		show: false,
	// 		text: 0,
	// 		color: "rgb(231, 90, 79)",
	// 		backgroundColor: "rgb(60, 60, 60)",
	// 	}
	// };

	wrapper.genTransitionClassNames();

	if (init) {
		
		wrapper.fullScreen = config.fullscreen || false;

		if (wrapper.fullScreenWidget != undefined) {
			wrapper.fullScreen = wrapper.fullScreenWidget;
		}

		wrapper.insertSDKScript();

		if (wrapper.autoStart || wrapper.allwaysAutoStart) {
			wrapper.handleStart();
		}
	} else {
		wrapper.loader.show = false;
	}
}

function getCookie(name) {
	const nameLenPlus = (name.length + 1);
	return document.cookie
		.split(';')
		.map(c => c.trim())
		.filter(cookie => {
			return cookie.substring(0, nameLenPlus) === `${name}=`;
		})
		.map(cookie => {
			return decodeURIComponent(cookie.substring(nameLenPlus));
		})[0] || null;
}


// WEBPACK FOOTER //
// ./src/helpers/configParser.js